import { createContext } from 'react';

/**
 * Set by `AvatarGroup` so every `Avatar` inside it draws one letter. A group's overlap and ring
 * cover the right edge of two letters at 32 and 40px, and no overlap clears the widest pairs ("WW")
 * at 32. A context rather than an `Avatar` prop, so the public API stays as small as it was; this
 * file is deliberately left out of `Avatar/index.ts`.
 */
export const SingleInitialContext = createContext(false);
